import { axios, base } from '../http';

/**
 * 运维台：钉钉推送样式试推（DingTalkPushOpsMaintenanceController）。创建于 2026-10-20
 */
export const dingTalkPushOpsSendTrial = (data) => {
  return axios.post(`${base}/api/DingTalkPushOpsMaintenance/SendTrial`, data);
};
